module.exports = __webpack_public_path__ + "static/media/08.c3e97dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/project/lacasadelturbo/08.png
// module id = 157
// module chunks = 0